<template>
  <transition name="fade">
    <div v-show="internalVisible" class="custom-loading-mask" :style="maskStyle" :class="customClass">
      <div class="custom-loading-spinner" :style="spinnerStyle">
        <!-- 点状动画 -->
        <div v-if="type === 'dots'" class="dots-spinner">
          <div
            v-for="i in 3"
            :key="i"
            class="dot"
            :style="
              spinnerColor
                ? {
                    animationDelay: `${(i - 1) * 0.15}s`,
                    backgroundColor: spinnerColor
                  }
                : ''
            "
          ></div>
        </div>

        <!-- 旋转动画 -->
        <div v-if="type === 'rotate'" class="rotate-spinner">
          <div
            class="rotate-circle"
            :style="spinnerColor ? { borderColor: `${spinnerColor} transparent transparent transparent` } : ''"
          ></div>
        </div>

        <!-- 脉冲动画 -->
        <div v-if="type === 'pulse'" class="pulse-spinner">
          <div class="pulse-circle" :style="spinnerColor ? { backgroundColor: spinnerColor } : ''"></div>
        </div>

        <!-- 波浪动画 -->
        <div v-if="type === 'wave'" class="wave-spinner">
          <div
            v-for="i in 5"
            :key="i"
            class="wave-bar"
            :style="
              spinnerColor
                ? {
                    animationDelay: `${(i - 1) * 0.1}s`,
                    backgroundColor: spinnerColor
                  }
                : ''
            "
          ></div>
        </div>

        <!-- 经典动画 -->
        <div v-if="type === 'classic'" class="classic-spinner">
          <div class="classic-circle"></div>
        </div>

        <!-- 自定义文本 -->
        <div v-if="text" class="loading-text" :style="{ color: textColor }">
          {{ text }}
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Loading",
  data() {
    return {
      internalVisible: false,
      type: "dots",
      background: "rgba(255, 255, 255, 0.7)",
      spinnerColor: "",
      text: "",
      textColor: "",
      zIndex: 2000,
      customClass: "",
      target: ""
    };
  },
  computed: {
    maskStyle() {
      return {
        backgroundColor: this.background,
        zIndex: this.zIndex
      };
    },
    spinnerStyle() {
      return {
        color: this.spinnerColor
      };
    }
  },
  methods: {
    show(options = {}) {
      // 更新配置
      Object.assign(this, options);
      this.internalVisible = true;
    },
    hide() {
      this.internalVisible = false;
    }
  }
};
</script>

<style scoped>
/* 保持原有的所有样式不变 */
.custom-loading-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.3s;
}

.custom-loading-spinner {
  text-align: center;
}

/* 淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* 点状动画 */
.dots-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: var(--color-primary);
  animation: dot-bounce 1.4s ease-in-out infinite both;
}

@keyframes dot-bounce {
  0%,
  80%,
  100% {
    transform: scale(0.6);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

/* 旋转动画 */
.rotate-spinner {
  display: inline-block;
  width: 40px;
  height: 40px;
}

.rotate-circle {
  box-sizing: border-box;
  display: block;
  width: 40px;
  height: 40px;
  border: 3px solid;
  border-radius: 50%;
  border-color: var(--color-primary) transparent transparent transparent;
  animation: rotate 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 脉冲动画 */
.pulse-spinner {
  display: inline-block;
  width: 40px;
  height: 40px;
}

.pulse-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: var(--color-primary);
  animation: pulse 1.2s ease-in-out infinite;
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
    opacity: 0.7;
  }
  50% {
    transform: scale(1.2);
    opacity: 1;
  }
  100% {
    transform: scale(0.8);
    opacity: 0.7;
  }
}

/* 波浪动画 */
.wave-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3px;
  height: 40px;
}

.wave-bar {
  width: 6px;
  height: 25px;
  border-radius: 3px;
  background-color: var(--color-primary);
  animation: wave 1.2s ease-in-out infinite;
}

@keyframes wave {
  0%,
  40%,
  100% {
    transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
  }
}

/* 经典动画 */
.classic-spinner {
  display: inline-block;
  width: 40px;
  height: 40px;
}

.classic-circle {
  box-sizing: border-box;
  display: block;
  width: 40px;
  height: 40px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid var(--color-primary);
  border-radius: 50%;
  animation: classic-rotate 1.2s linear infinite;
}

@keyframes classic-rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 加载文字 */
.loading-text {
  margin-top: 12px;
  font-size: 14px;
  line-height: 1.4;
  color: var(--color-primary);
}
</style>
